import { useEffect, useState } from "react";
import Switch from "@mui/material/Switch";
import { FormControlLabel, FormGroup, Box } from "@mui/material";
import "./Photos.css";

const ToggleFloodRenderings = ({
 id,
 photoLocationsLayer,
 floodRenderingsVisible,
 setFloodRenderingsVisible,
}) => {
 const [toggleSwitch, setToggleSwitch] = useState(true);

 useEffect(() => {
  if (!!photoLocationsLayer) {
   if (!!!toggleSwitch) {
    photoLocationsLayer.visible = false;
    setFloodRenderingsVisible(false);
   } else {
    photoLocationsLayer.visible = true;
    setFloodRenderingsVisible(true);
   }
  }
 }, [toggleSwitch]);

 return (
  <Box
   id={id}
   className="critical-facilities-widget-container"
   sx={{
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    p: "0px 0px 0px 4px",
    height: "34px",
    width: "219px",
    mb: 1,
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
   }}
  >
   {/* 1. the switch component is used to toggle critical facilities layer(s) */}
   <FormGroup sx={{ ml: "12px" }}>
    <FormControlLabel
     sx={{
      color: `${!!toggleSwitch ? "#151515" : "#6e6e6e"}`,
      fontSize: "14px",
      lineHeight: "1.3em",
     }}
     control={
      <Switch
       sx={{ mr: 1 }}
       size="small"
       checked={toggleSwitch}
       onChange={() => {
        setToggleSwitch(!!!toggleSwitch);
       }}
       inputProps={{ "aria-label": "controlled" }}
      />
     }
     label="360 Renderings"
    />
   </FormGroup>
  </Box>
 );
};

export default ToggleFloodRenderings;
